import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { each } from 'lodash';
import { trackClick, trackImpression } from '../lib/helpers';
import RecommendedToolsCard from './RecommendedToolsCard';

class RecommendedTools extends React.Component {
  handleClick = async tool => {
    const { app } = this.props,
      { FPTI, link } = tool,
      { customTrackingURLS, fptiName } = link;

    // OnClick, we are firing the following instrumentations:
    //    - FPTI Click with `fptiName` as link
    //    - MORS + Feedback URLs (i.e. `customTrackingURLS` under the link object)
    //      as regular GET requests
    trackClick({
      custId: app.custId,
      link: fptiName,
      ...FPTI
    });

    each(customTrackingURLS, url => {
      // make sure the redirect happens after last fetch
      fetch(url, {
        credentials: 'same-origin'
      });
    });
  };

  componentDidMount() {
    const { app, recommendations } = this.props;
    each(recommendations, tool => {
      const { customTrackingURLS, FPTI } = tool;

      // On each card render, we are firing the following instrumentations:
      //    - FPTI Impression
      //    - MORS URLs (i.e. `customTrackingURLS` under the tool object)
      //      as regular GET requests
      trackImpression({
        custId: app.custId,
        ...FPTI
      });

      each(customTrackingURLS, url => {
        fetch(url, {
          credentials: 'same-origin'
        });
      });
    });
  }

  render() {
    const { recommendations } = this.props;

    // do not render if recommendations is empty
    if (!recommendations.length) return null;

    return (
      <Fragment>
        {recommendations.slice(0, 3).map((tool, index) => {
          return (
            <RecommendedToolsCard
              key={`recommendation-tool-${index}`}
              tool={tool}
              handleClick={this.handleClick}
            />
          );
        })}
      </Fragment>
    );
  }
}

RecommendedTools.propTypes = {
  app: PropTypes.object,
  tracking: PropTypes.object,
  recordClick: PropTypes.func,
  recommendations: PropTypes.array
};

export default RecommendedTools;
